import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const telegramUsername = "/MoGame_Support";
const telegramLink = `https://t.me/${telegramUsername}`;

export default function AccordionComponent() {
  return (
    <div style={{ maxWidth: "800px", width: "100%", margin: "0 auto" }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          Подходит ли MOGAME для корпоративного обучения?
        </AccordionSummary>
        <AccordionDetails>
          Да. Вы создаёте сценарий обучения, загружаете видео-материалы и
          выдаёте ключи доступа сотрудникам. Формат подходит для адаптации,
          продуктовых тренингов, регламентов и любых программ, где важна
          вовлечённость.
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          Можно ли продавать курсы через платформу?
        </AccordionSummary>
        <AccordionDetails>
          Да. Вы создаёте интерактивный курс и выдаёте ключи доступа
          покупателям — индивидуально или группами. Это удобно и для продажи
          авторских программ, и для корпоративных контрактов с компаниями.
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          Чем интерактивный сценарий лучше обычного видео-курса?
        </AccordionSummary>
        <AccordionDetails>
          Ученик не просто смотрит запись — он принимает решения и проходит
          свой путь. Сценарий позволяет адаптировать материал под разные роли,
          уровни подготовки или ситуации. Это повышает вовлечённость и лучше
          закрепляет материал.
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4-content"
          id="panel4-header"
        >
          Куда обращаться при вопросах по запуску курса?
        </AccordionSummary>
        <AccordionDetails>
          По любым вопросам вы можете{" "}
          <a href={telegramLink} target="_blank" rel="noopener noreferrer">
            написать в поддержку
          </a>
          . Специалисты отвечают с 9 до 20 часов по московскому времени.
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
